module.exports = __webpack_public_path__ + "static/media/dark-preview.a8df0346.png";